/* ===================================================
VEAMS SETTINGS
=================================================== */
/* ===================================================
BREAKPOINT SETTINGS
=================================================== */
/* ===================================================
FONTS
=================================================== */
/* ===================================================
FONTSIZES
=================================================== */
/* ===================================================
COLORS
=================================================== */
/* ===================================================
Transitions
=================================================== */
/* ===================================================
Padding / Margin
=================================================== */
/* ===================================================
Misc
=================================================== */
/* ===================================================
Buttons
=================================================== */
/* ===================================================
VEAMS SETTINGS
=================================================== */
/* ===================================================
BREAKPOINT SETTINGS
=================================================== */
/* ===================================================
FONTS
=================================================== */
/* ===================================================
FONTSIZES
=================================================== */
/* ===================================================
COLORS
=================================================== */
/* ===================================================
Transitions
=================================================== */
/* ===================================================
Padding / Margin
=================================================== */
/* ===================================================
Misc
=================================================== */
/* ===================================================
Buttons
=================================================== */
/* ===================================================
EXTENDED SETTINGS
=================================================== */
/* ===================================================
VEAMS SETTINGS
=================================================== */
/* ===================================================
BREAKPOINT SETTINGS
=================================================== */
/* ===================================================
FONTS
=================================================== */
/* ===================================================
FONTSIZES
=================================================== */
/* ===================================================
COLORS
=================================================== */
/* ===================================================
Transitions
=================================================== */
/* ===================================================
Padding / Margin
=================================================== */
/* ===================================================
Misc
=================================================== */
/* ===================================================
Buttons
=================================================== */
/* ===================================================
BREAKPOINT SETTINGS
=================================================== */
:host([error]) {
  background-color: #ff74a2;
}

:host([alert]) {
  background-color: #ffc270;
}

:host([success]) {
  background-color: #85d0c1;
}

:host([info]) {
  background-color: #8494ff;
}

:host([dark]) {
  background-color: #0a171f;
  color: #fff;
}

:host([accent]) {
  background-color: #eaf7ff;
}

:host([info]) {
  display: inline-block;
  margin-right: 2em;
}

/* top, bottom and y paddings */
:host([p-0]), :host([pt-0]), :host([py-0]) {
  padding-top: 0;
}

:host([p-0]), :host([pb-0]), :host([py-0]) {
  padding-bottom: 0;
}

:host([p-1]), :host([pt-1]), :host([py-1]), ::slotted([p-1]), ::slotted([pt-1]), ::slotted([py-1]) {
  padding-top: 12px;
}

:host([p-1]), :host([pb-1]), :host([py-1]), ::slotted([p-1]), ::slotted([pb-1]), ::slotted([py-1]) {
  padding-bottom: 12px;
}

:host([p-2]), :host([pt-2]), :host([py-2]), ::slotted([p-2]), ::slotted([pt-2]), ::slotted([py-2]) {
  padding-top: 24px;
}

:host([p-2]), :host([pb-2]), :host([py-2]), ::slotted([p-2]), ::slotted([pb-2]), ::slotted([py-2]) {
  padding-bottom: 24px;
}

:host([p-3]), :host([pt-3]), :host([py-3]), ::slotted([p-3]), ::slotted([pt-3]), ::slotted([py-3]) {
  padding-top: 32px;
}

:host([p-3]), :host([pb-3]), :host([py-3]), ::slotted([p-3]), ::slotted([pb-3]), ::slotted([py-3]) {
  padding-bottom: 32px;
}

:host([p-4]), :host([pt-4]), :host([py-4]), ::slotted([p-4]), ::slotted([pt-4]), ::slotted([py-3]) {
  padding-top: 40px;
}

:host([p-4]), :host([pb-4]), :host([py-4]), ::slotted([p-4]), ::slotted([pb-4]), ::slotted([py-4]) {
  padding-bottom: 40px;
}

:host([p-5]), :host([pt-5]), :host([py-5]) {
  padding-top: 80px;
}

:host([p-5]), :host([pb-5]), :host([py-5]) {
  padding-bottom: 80px;
}

/* left, right and x paddings */
:host([p-0]), :host([pl-0]), :host([px-0]) {
  padding-left: 0;
}

:host([p-0]), :host([pr-0]), :host([px-0]) {
  padding-right: 0;
}

:host([p-1]), :host([pl-1]), :host([px-1]) {
  padding-left: 12px;
}

:host([p-1]), :host([pr-1]), :host([px-1]) {
  padding-right: 12px;
}

:host([p-2]), :host([pl-2]), :host([px-2]) {
  padding-left: 24px;
}

:host([p-2]), :host([pr-2]), :host([px-2]) {
  padding-right: 24px;
}

:host([p-3]), :host([pl-3]), :host([px-3]) {
  padding-left: 32px;
}

:host([p-3]), :host([pr-3]), :host([px-2]) {
  padding-right: 32px;
}

:host([p-4]), :host([pl-4]), :host([px-4]) {
  padding-left: 40px;
}

:host([p-4]), :host([pr-4]), :host([px-4]) {
  padding-right: 40px;
}

:host([p-5]), :host([pl-5]), :host([px-5]) {
  padding-left: 80px;
}

:host([p-5]), :host([pr-5]), :host([px-5]) {
  padding-right: 80px;
}

/* ToDo: Own Mixin for layout */
:host([layout-stretch]), ::slotted([layout-stretch]) {
  display: flex;
  flex-direction: row;
  align-content: space-between;
}

/* ===================================================
BREAKPOINT SETTINGS
=================================================== */
/* ===================================================
Reset Button
=================================================== */
/*
Extend
----------------------- */
/* ===================================================
VEAMS SETTINGS
=================================================== */
/* ===================================================
BREAKPOINT SETTINGS
=================================================== */
/* ===================================================
FONTS
=================================================== */
/* ===================================================
FONTSIZES
=================================================== */
/* ===================================================
COLORS
=================================================== */
/* ===================================================
Transitions
=================================================== */
/* ===================================================
Padding / Margin
=================================================== */
/* ===================================================
Misc
=================================================== */
/* ===================================================
Buttons
=================================================== */
/* ===================================================
BREAKPOINT SETTINGS
=================================================== */
/* ===================================================
VEAMS SETTINGS
=================================================== */
/* ===================================================
BREAKPOINT SETTINGS
=================================================== */
/* ===================================================
FONTS
=================================================== */
/* ===================================================
FONTSIZES
=================================================== */
/* ===================================================
COLORS
=================================================== */
/* ===================================================
Transitions
=================================================== */
/* ===================================================
Padding / Margin
=================================================== */
/* ===================================================
Misc
=================================================== */
/* ===================================================
Buttons
=================================================== */
/* ---------------------------------------------------
A11y-focus
--------------------------------------------------- */
/* ===================================================
Reset Button
=================================================== */
/*
Extend
----------------------- */
/* ===================================================
Pseudo Element
=================================================== */
/*
Extend
----------------------- */
/* ===================================================
Button and Link Styles
=================================================== */
/* ===================================================
Hiding Elements
=================================================== */
/* ---------------------------------------------------
ir
--------------------------------------------------- */
/* ---------------------------------------------------
Hidden
--------------------------------------------------- */
/* ---------------------------------------------------
Visually hidden
--------------------------------------------------- */
/* ---------------------------------------------------
Visibility hidden
--------------------------------------------------- */
/* ---------------------------------------------------
Hide text
--------------------------------------------------- */
/* ===================================================
Pseudo Element
=================================================== */
/*
Extend
----------------------- */
/* ===================================================
CENTERING MIXIN
=================================================== */
/* ===================================================
VEAMS SETTINGS
=================================================== */
/* ===================================================
BREAKPOINT SETTINGS
=================================================== */
/* ===================================================
FONTS
=================================================== */
/* ===================================================
FONTSIZES
=================================================== */
/* ===================================================
COLORS
=================================================== */
/* ===================================================
Transitions
=================================================== */
/* ===================================================
Padding / Margin
=================================================== */
/* ===================================================
Misc
=================================================== */
/* ===================================================
Buttons
=================================================== */
/* ===================================================
VEAMS SETTINGS
=================================================== */
/* ===================================================
BREAKPOINT SETTINGS
=================================================== */
/* ===================================================
FONTS
=================================================== */
/* ===================================================
FONTSIZES
=================================================== */
/* ===================================================
COLORS
=================================================== */
/* ===================================================
Transitions
=================================================== */
/* ===================================================
Padding / Margin
=================================================== */
/* ===================================================
Misc
=================================================== */
/* ===================================================
Buttons
=================================================== */
/* ===================================================
EXTENDED SETTINGS
=================================================== */
/* ===================================================
VEAMS SETTINGS
=================================================== */
/* ===================================================
BREAKPOINT SETTINGS
=================================================== */
/* ===================================================
FONTS
=================================================== */
/* ===================================================
FONTSIZES
=================================================== */
/* ===================================================
COLORS
=================================================== */
/* ===================================================
Transitions
=================================================== */
/* ===================================================
Padding / Margin
=================================================== */
/* ===================================================
Misc
=================================================== */
/* ===================================================
Buttons
=================================================== */
/* ===================================================
BREAKPOINT SETTINGS
=================================================== */
:host {
  font-size: var(--fontsize-link, inherit);
  line-height: calc(var(--fontsize-link, inherit) + .4rem);
  align-items: center;
  cursor: pointer;
  display: inline-flex;
  font-style: italic;
  justify-content: center;
  text-decoration: underline;
}
@media only screen and (min-width: 414px) {
  :host {
    font-size: calc(var(--fontsize-link, inherit) + calc(.1rem * 1));
    line-height: calc(calc(var(--fontsize-link, inherit) + .4rem) + calc(.1rem * 1));
  }
}
@media only screen and (min-width: 768px) {
  :host {
    font-size: calc(var(--fontsize-link, inherit) + calc(.2rem * 1));
    line-height: calc(calc(var(--fontsize-link, inherit) + .4rem) + calc(.2rem * 1));
  }
}
@media only screen and (min-width: 960px) {
  :host {
    font-size: calc(var(--fontsize-link, inherit) + calc(.3rem * 1));
    line-height: calc(calc(var(--fontsize-link, inherit) + .4rem) + calc(.3rem * 1));
  }
}
@media only screen and (min-width: 1120px) {
  :host {
    font-size: calc(var(--fontsize-link, inherit) + calc(.4rem * 1));
    line-height: calc(calc(var(--fontsize-link, inherit) + .4rem) + calc(.4rem * 1));
  }
}
:host ::slotted(span) {
  font-size: var(--fontsize-link, inherit);
  line-height: calc(var(--fontsize-link, inherit) + .4rem);
  text-decoration: var(--link-underline, inherit);
}
@media only screen and (min-width: 414px) {
  :host ::slotted(span) {
    font-size: calc(var(--fontsize-link, inherit) + calc(.1rem * 1));
    line-height: calc(calc(var(--fontsize-link, inherit) + .4rem) + calc(.1rem * 1));
  }
}
@media only screen and (min-width: 768px) {
  :host ::slotted(span) {
    font-size: calc(var(--fontsize-link, inherit) + calc(.2rem * 1));
    line-height: calc(calc(var(--fontsize-link, inherit) + .4rem) + calc(.2rem * 1));
  }
}
@media only screen and (min-width: 960px) {
  :host ::slotted(span) {
    font-size: calc(var(--fontsize-link, inherit) + calc(.3rem * 1));
    line-height: calc(calc(var(--fontsize-link, inherit) + .4rem) + calc(.3rem * 1));
  }
}
@media only screen and (min-width: 1120px) {
  :host ::slotted(span) {
    font-size: calc(var(--fontsize-link, inherit) + calc(.4rem * 1));
    line-height: calc(calc(var(--fontsize-link, inherit) + .4rem) + calc(.4rem * 1));
  }
}
:host ::slotted(:nth-child(2)),
:host .c-link__icon {
  margin-left: 4px;
}
:host ::slotted(c-icon),
:host .c-link__icon {
  height: var(--iconsize-link, 1.6rem);
  align-self: flex-start;
  color: currentColor;
  line-height: 1;
}
@media only screen and (min-width: 414px) {
  :host ::slotted(c-icon),
:host .c-link__icon {
    height: calc(var(--iconsize-link, 1.6rem) + .1rem);
  }
}
@media only screen and (min-width: 768px) {
  :host ::slotted(c-icon),
:host .c-link__icon {
    height: calc(var(--iconsize-link, 1.6rem) + .2rem);
  }
}
@media only screen and (min-width: 960px) {
  :host ::slotted(c-icon),
:host .c-link__icon {
    height: calc(var(--iconsize-link, 1.6rem) + .3rem);
  }
}
@media only screen and (min-width: 1120px) {
  :host ::slotted(c-icon),
:host .c-link__icon {
    height: calc(var(--iconsize-link, 1.6rem) + .4rem);
  }
}
:host .c-link__icon--before {
  align-self: center;
  margin-left: 0;
  margin-right: 8px;
  order: 1;
}
:host .c-link__text--after {
  font-style: normal;
  order: 2;
}

:host(:hover),
:host(:focus) {
  color: #3779a3;
  outline: none;
}

/*
  Modifiers
*/
:host([primary]),
:host([primary]:hover) {
  color: #3779a3;
  text-decoration: none;
}

:host([primary]:hover) {
  text-decoration: underline;
}

:host([block]) {
  align-items: flex-start;
  display: flex;
  justify-content: space-between;
  padding: 8px;
  width: auto;
}

@media only screen and (min-width: 960px) {
  :host([href^="tel:"]) {
    font-style: normal;
    pointer-events: none;
    text-decoration: none;
  }
}

:host([block][centered]) {
  display: block;
  margin: 0 auto;
  text-align: center;
  width: max-content;
}

:host([disabled]) {
  cursor: not-allowed;
  opacity: 0.5;
  pointer-events: none;
}

:host([alert]) {
  color: #ff74a2;
}

:host([alert]:hover),
:host([alert]:focus) {
  color: #000;
}